import { SVGProps } from 'react';

const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
        <path d="M7 10.026a2.1 2.1 0 0 1-2.1-2.1c0-.784.427-1.47 1.05-1.827l6.797-3.934-3.871 6.706A2.104 2.104 0 0 1 7 10.026Zm0-9.1c1.267 0 2.45.35 3.479.924l-1.47.847A5.6 5.6 0 0 0 1.4 7.926c0 1.547.623 2.947 1.638 3.955h.007a.697.697 0 0 1 0 .987.712.712 0 0 1-.994.007A7 7 0 0 1 7 .926Zm7 7a6.978 6.978 0 0 1-2.051 4.95.704.704 0 0 1-.987-.008.697.697 0 0 1 0-.987A5.564 5.564 0 0 0 12.6 7.926c0-.7-.133-1.4-.378-2.03l.847-1.47c.581 1.05.931 2.226.931 3.5Z" />
    </svg>
);
export default SvgDashboard;
